@if (!html) {
<svg style="width: {{ size }}; height: {{ size }}"></svg>
}
@if (html) {
<svg [outerHTML]="html"></svg>
}
